export default __webpack_public_path__ + "static/media/Steel City-5.92ea772a.jpg";